// This file is auto-generated by scripts/generate-version.js
// Do not edit manually - it will be overwritten on build

export const version = {
  gitCommit: 'af2257e32',
  buildTime: '2026-11-04T18:16:56.368Z',
} as const;
